angular.module('bmsApp.crm.salespipeline', [
	'ui.router',
])
	.config([
		'$stateProvider', function config(
			$stateProvider) {

			$stateProvider

				.state('main.crm.salespipeline', {
					abstract: true,
					views: {
						'main@main': {
							templateUrl: 'ng/crm/salesPipeline/templates/SalesPipelineMain.html',
							controller: 'SalesPipelineMainCtrl'
						}
					}
				})
				.state('main.crm.salespipeline.index', {
					url: '^/crm/salespipeline',
					views: {
						'content@main.crm.salespipeline': {
							templateUrl: 'ng/crm/salesPipeline/templates/SalesPipelineIndex.html',
							controller: 'SalesPipelineIndexCtrl'
						},
						'side@main.crm.salespipeline': {
							templateUrl: "ng/crm/salesPipeline/templates/SalesPipelineSide.html"
						}
					},
					ncyBreadcrumb: {label: 'Sales Pipeline'}
				})
			;

		}]);
